import { a as o } from "../../../chunk-OA3DH5LS-40f95340.js";
const t = o("CheckboxList").parts(
  "checkboxListContainer",
  "checkboxListContainerPositionRight",
  "container",
  "individualCheckbox",
  "individualCheckboxRight",
  "rootCheckbox",
  "rootCheckboxRight"
);
export {
  t as CheckboxListAnatomy
};
//# sourceMappingURL=CheckboxList.anatomy.es.js.map
